"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadAttachmentsTile = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
// @ts-nocheck
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var react_dropzone_1 = require("react-dropzone");
var react_common_lib_1 = require("@esub-engineering/react-common-lib");
var Tile_1 = require("../Tile");
var styles_1 = __importDefault(require("./styles"));
exports.UploadAttachmentsTile = react_1.default.memo(function (_a) {
    var _b = _a.acceptedFileTypes, acceptedFileTypes = _b === void 0 ? react_common_lib_1.supportedFileMimes : _b, multiple = _a.multiple, _c = _a.maxFileSizeMB, maxFileSizeMB = _c === void 0 ? 200 : _c, _d = _a.onChange, onChange = _d === void 0 ? function () { } : _d, _e = _a.onError, onError = _e === void 0 ? function () { } : _e, onFileDropError = _a.onFileDropError, _f = _a.iconSize, iconSize = _f === void 0 ? 64 : _f, rest = __rest(_a, ["acceptedFileTypes", "multiple", "maxFileSizeMB", "onChange", "onError", "onFileDropError", "iconSize"]);
    var classes = (0, styles_1.default)();
    var maxSizeBytes = 1048576 * maxFileSizeMB;
    var handleError = function () {
        onError();
    };
    var handleDrop = function (droppedFiles) {
        if (!droppedFiles)
            return;
        try {
            var hasBadFiles = Array.from(droppedFiles).some(function (file) { return file.size > maxSizeBytes && (0, react_common_lib_1.isSupportedFile)(file); });
            if (hasBadFiles) {
                onFileDropError();
                throw new Error("File(s) were too large or were of an unsupported type.");
            }
            // NOTE: state is handled outside of this component
            onChange(droppedFiles);
        }
        catch (ex) {
            // eslint-disable-next-line no-console
            console.error("An error occurred while dropping files", ex);
            onError();
        }
    };
    var _g = (0, react_dropzone_1.useDropzone)({
        accept: acceptedFileTypes.join(","),
        onDropAccepted: handleDrop,
        onDropRejected: handleError,
    }), getRootProps = _g.getRootProps, getInputProps = _g.getInputProps;
    // get props from dropzone, and remove refs as they are not used / forwarded
    var _h = getRootProps(), rootRef = _h.ref, rootProps = __rest(_h, ["ref"]);
    var inputProps = __rest(getInputProps(), []);
    return ((0, jsx_runtime_1.jsxs)(Tile_1.Tile, __assign({ removable: false, "aria-label": "upload files", nameVisible: false }, rest, rootProps, { children: [(0, jsx_runtime_1.jsx)(core_1.Icon, __assign({ component: "div", className: classes.icon, color: "primary" }, { children: (0, jsx_runtime_1.jsx)(icons_1.Add, { color: "primary", style: { fontSize: iconSize } }) })), (0, jsx_runtime_1.jsx)("input", __assign({ id: "".concat(rest.idPrefix, "FileInput"), multiple: multiple, accept: acceptedFileTypes.join(","), type: "file" }, inputProps, { 
                // invisible means that it is not accessible, so "hide" another way
                className: classes.hiddenFileInput }))] })));
});
